/* global window */
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form, Field } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { RadioButton } from 'common/components/forms';
import { FormError } from 'common/components/layout';
import { isPreSale, isDarioush } from 'common/helpers/featureFlags';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import { updateAndProcessClubSignup } from 'redux/clubSignup/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';
import { listCustomerCreditCards } from 'redux/customerCreditCards/actions';

import AddressPicker from './components/AddressPicker';
import CreditCardLoggedIn from './components/CreditCardLoggedIn';
import FrequencyPicker from './components/FrequencyPicker';
import {
  validateAddressForLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 'shipping'
    };
  }

  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
    props.listCustomerCreditCards();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, this.props);
    const clubSignup = {
      creditCard: data.creditCard,
      billTo: data.address,
      clubId: props.club.id
    };
    if (props.club.type === 'Subscription') {
      clubSignup.subscription = data.subscription;
    }
    const successFunction = (membership) => {
      if (isDarioush()) {
        window.location.href = `/membership/welcome/${membership.id}`;
      } else {
        props.history.push(`/club/receipt/${membership.id}`);
      }
    };
    props.updateAndProcessClubSignup(clubSignup, successFunction);
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('customer');
  };

  handleSameAsBilling = (e) => {
    this.setState({ selectedOption: e.currentTarget.value });
  };

  render() {
    const { club, clubSignup, handleSubmit, change, form } = this.props;
    const { customerAddresses, customerCreditCards, settings } = this.props;
    const { selectedCreditCardId } = this.props;
    const { selectedOption } = this.state;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (clubSignup.shipTo) {
      object = clubSignup.shipTo;
    }
    let clubSignup1 = 'Club';
    if (isPreSale()) {
      clubSignup1 = 'Pre-Sale';
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <CreditCardLoggedIn
          customerCreditCards={customerCreditCards}
          selectedCreditCardId={selectedCreditCardId}
        />

        {club.type === 'Subscription' && (
          <>
            <h3>Subscription</h3>
            <FrequencyPicker />
          </>
        )}

        <h3>Billing address</h3>
        <div className="c7-checkout__content__radio-options-group">
          <Field
            name="isSameAsBillingAddress"
            component={RadioButton}
            label="Same as shipping address"
            onChange={this.handleSameAsBilling}
            type="radio"
            value="shipping"
          />

          <Field
            name="isSameAsBillingAddress"
            component={RadioButton}
            label="Use a different billing address"
            onChange={this.handleSameAsBilling}
            type="radio"
            value="billing"
          />

          <div
            className="c7-checkout__content__radio-options-group__edit"
            style={{ display: selectedOption === 'shipping' && 'none' }}
          >
            <AddressPicker
              customerAddresses={customerAddresses.data}
              onAddressChange={this.handleAddressChange}
            />
            <AddressForm
              object={object}
              changeFunction={change}
              settings={settings}
            />
          </div>
        </div>

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Complete {clubSignup1} Sign Up
          </button>
          <a onClick={this.handleBack}>Return to shipping method</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  let address;
  let creditCard;
  let subscription;
  if (values.isSameAsBillingAddress === 'billing') {
    address = transformAddressData(values);
    address.customerAddressId = values.customerAddressId;
  } else {
    address = props.clubSignup.shipTo;
    delete address.id;
  }
  if (!values.customerCreditCardId || values.customerCreditCardId === '') {
    creditCard = {
      cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
      expiryMo: values.expiryMo && integerFormat(values.expiryMo),
      expiryYr: values.expiryYr && integerFormat(values.expiryYr),
      cvv2: values.cvv2,
      cardHolderName: values.cardHolderName
    };
  } else {
    creditCard = {
      customerCreditCardId: values.customerCreditCardId
    };
  }
  if (props.club.type === 'Subscription') {
    subscription = {
      frequency: integerFormat(values.frequency)
    };
  }
  return { address, creditCard, subscription };
};

const validate = (values, props) => {
  let errors = {};
  if (values.isSameAsBillingAddress === 'billing') {
    const { address } = transformData(values, props);
    address.birthDay =
      values.birthDay && convertStringToInteger(values.birthDay);
    address.birthMonth =
      values.birthMonth && convertStringToInteger(values.birthMonth);
    address.birthYear =
      values.birthYear && convertStringToInteger(values.birthYear);
    errors = Object.assign(
      errors,
      validateAddressForLoggedInCustomer(address, props.settings)
    );
  }
  if (!values.customerCreditCardId || values.customerCreditCardId === '') {
    const { creditCard } = transformData(values, props);
    errors = Object.assign(errors, validateCreditCard(creditCard));
  }
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  let selectedCreditCardId;
  if (state.clubSignup?.data) {
    const { billTo } = state.clubSignup.data;
    initialValues = initialFormValues(billTo);
    if (state.clubSignup.data.club.type === 'Subscription') {
      initialValues.frequency = state.clubSignup.data.subscription.frequency;
    }
    initialValues.isSameAsBillingAddress = 'shipping';
    const { creditCard } = state.clubSignup.data;
    if (creditCard) {
      initialValues.customerCreditCardId = creditCard.customerCreditCardId;
      selectedCreditCardId = creditCard.customerCreditCardId;
    }
  }
  return {
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    customerCreditCards: state.customerCreditCard,
    initialValues,
    selectedCreditCardId
  };
};

Payment = reduxForm({
  form: 'paymentLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, {
    updateAndProcessClubSignup,
    listCustomerAddresses,
    listCustomerCreditCards
  })(Payment)
);
